import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';

interface StatusChipIconProps {
  status?: string;
}

export const StatusChipIcon: React.FC<StatusChipIconProps> = ({ status }) => {
  const { t } = useTranslation();

  switch (status) {
    case '10':
      return (
        <Chip
          icon={<CheckCircleIcon />}
          label={t('Validated')}
          size="small"
          color="success"
        />
      );

    case '95':
      return (
        <Chip
          label={t('Unvalidated')}
          size="small"
          color="primary"
        />
      );

    case '85':
      return (
        <Chip
          icon={<CancelIcon />}
          label={t('Cancelled')}
          size="small"
          color="error"
        />
      );

    default:
      return null;
  }
};
